import { render, staticRenderFns } from "./VideoPlayerFour.vue?vue&type=template&id=a8b14c50&"
import script from "./VideoPlayerFour.vue?vue&type=script&lang=js&"
export * from "./VideoPlayerFour.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayerFour.vue?vue&type=style&index=0&id=a8b14c50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports